/**
 * Color palette configuration for the theme
 */
export const palette = {
  mode: 'light',
  primary: {
    main: '#3A5985',
    light: '#618FCA',
    dark: '#2B4364',
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#618FCA',
    light: '#89AFE0',
    dark: '#3A5985',
    contrastText: '#ffffff',
  },
  background: {
    default: '#E5EDFF',
    paper: '#ffffff',
  },
  text: {
    primary: '#1D2B3A',
    secondary: '#51677E',
  },
  divider: '#D5DEEF',
  action: {
    hover: 'rgba(58, 89, 133, 0.08)',
    selected: 'rgba(58, 89, 133, 0.16)',
  },
  error: {
    main: '#d32f2f',
    light: '#ef5350',
    dark: '#c62828',
  },
  warning: {
    main: '#ed6c02',
    light: '#ff9800',
    dark: '#e65100',
  },
  info: {
    main: '#89AFE0',
    light: '#B2CAEE',
    dark: '#618FCA',
    contrastText: '#1D2B3A',
  },
  success: {
    main: '#2e7d32',
    light: '#4caf50',
    dark: '#1b5e20',
  },
};
